<template>
  <v-container class="px-8 pt-0 pb-8 fill-height">

    <v-row>
      <v-col
        cols="12" md="6"
        class="mr-8">
        <v-row>
          <v-col class="langSelectMenuBtnDiv pt-2 mb-8">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  light icon
                  title="language"
                  name="language"
                  v-bind="attrs"
                  v-on="on">
                  <!-- <v-img :src="$store.getters.selectedLanguage.flag" max-width="16"></v-img> -->
                  <v-img :src="selectedLanguageDetails.flag" max-width="16"></v-img>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="(item, index) in language.items"
                  :key="index"
                  @click="changeLanguage(item)">
                  <v-list-item-title><v-img :alt="item.value" :src="item.flag" width="16"></v-img></v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="$route.path.endsWith('/energia-monitor')"
                  @click="setLangDe(true)">
                  <v-list-item-title><v-img src="@/assets/flag-de.png" width="16"></v-img></v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="font-weight: 300; letter-spacing: 1.8px; max-width: 450px;" :style="mini ? 'font-size: 52px; line-height: 52px;' : 'font-size: 80px ;line-height: 80px;'">
            {{ $t('pageNotFound.title')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0" style="max-width: 450px;" :style="mini ? 'font-size: 13px; line-height: 18px;' : ''">
            {{ $t('pageNotFound.message')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-8 caption" style="max-width: 450px; line-height: 18px;">
            {{ $t('common.phoneNumber')}}: <span id="phoneNumberSpan" class="caption mouse-hover-link mr-4" style="font-weight:600;" @click="openPhone('+3614694020')">+36 1 469 40 20</span><br>
            {{ $t('common.email')}}: <span id="emailSpan" class="caption mouse-hover-link" style="font-weight:600;" @click="openMail('info@rubin.hu')">info@rubin.hu</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
            color="primary"
            depressed tile
            @click="loadPage('Home')">
              {{ $t('pageNotFound.button')}}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12" md="5"
        class="d-flex align-center"
        style="font-size: 240px; font-weight: 800; letter-spacing: -30px; line-height: 200px;">
          404
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'PageNotFound',
    extends: DataComponentBase,

    computed: {
      mini() {
        return this.styleProps.windowWidth < 960 && this.styleProps.windowHeight < 800
      }
    },

    methods: {
      openMail(email) {
        window.location ='mailto:' + email;
      },
      openPhone(phoneNumber) {
        window.location ='tel:' + phoneNumber;
      },
    }
  }
</script>

<style>

</style>